export const API_KEY = 'JwUuWz6SaKlp0LWOh7TGOxBFRzG5cXG61xK_RHzmtg0';